import { agentControllerPermissionModeSchema } from "../agent-controller-permission-mode.js";
import { daemonServiceLaneSchema } from "./service-contract.js";
import { agentProfileIdSchema } from "../protocol/profile.js";
import { conversationPolicySchema } from "./conversation-contract.js";
import { runtimeAgentControllerConversationIdMappingSpecSchema, runtimeAgentControllerLaunchContractSchema, runtimeStreamingModeSchema, runtimeTransportModeSchema } from "./controller-contract.js";
import { skippedDaemonProfileSchema } from "./control-plane.js";
import { CURRENT_DAEMON_EXECUTION_CONTRACT_EPOCH } from "./runtime-transport.js";
import { openCodePermissionConfigSchema } from "../open-code-permission.js";
import { z } from "zod/v4";
//#region src/schemas/daemon/route-catalog-cache.ts
const DAEMON_ROUTE_CATALOG_CACHE_SCHEMA_VERSION = 2;
const DAEMON_ROUTE_CATALOG_CACHE_SCHEMA_NAME = "wakeloop-daemon-route-catalog-cache-v2";
const cachedDaemonRouteConfigSchema = z.strictObject({
	agentControllerRef: z.string().trim().min(1),
	agentControllerPermissionMode: agentControllerPermissionModeSchema.optional(),
	contextIdMappingSpec: runtimeAgentControllerConversationIdMappingSpecSchema,
	conversationPolicy: conversationPolicySchema.optional(),
	openCodePermission: openCodePermissionConfigSchema.optional(),
	launchContract: runtimeAgentControllerLaunchContractSchema.nullable().optional(),
	profileId: agentProfileIdSchema,
	streamingMode: runtimeStreamingModeSchema,
	transportMode: runtimeTransportModeSchema
});
const daemonRouteCatalogCacheSchema = z.strictObject({
	v: z.literal(2),
	schema: z.literal(DAEMON_ROUTE_CATALOG_CACHE_SCHEMA_NAME),
	cachedAt: z.iso.datetime({ offset: true }),
	runtimeContractEpoch: z.literal(CURRENT_DAEMON_EXECUTION_CONTRACT_EPOCH),
	ownerUserId: z.string().trim().min(1),
	lane: daemonServiceLaneSchema,
	serviceBundleId: z.string().trim().min(1),
	profileIds: z.array(agentProfileIdSchema),
	routes: z.array(cachedDaemonRouteConfigSchema),
	skippedProfiles: z.array(skippedDaemonProfileSchema)
}).superRefine((value, ctx) => {
	const routeIds = new Set(value.routes.map((route) => route.profileId));
	for (const profileId of value.profileIds) if (!routeIds.has(profileId)) ctx.addIssue({
		code: "custom",
		message: "route catalog cache profileIds must match routes",
		path: ["profileIds"]
	});
});
//#endregion
export { DAEMON_ROUTE_CATALOG_CACHE_SCHEMA_NAME, DAEMON_ROUTE_CATALOG_CACHE_SCHEMA_VERSION, cachedDaemonRouteConfigSchema, daemonRouteCatalogCacheSchema };

//# sourceMappingURL=route-catalog-cache.js.map